import { pipe } from 'fp-ts/lib/function';
import {
  createAuthorizedDeleteRequest,
  createAuthorizedPostRequest,
  fetchApi, setBody,
} from '@/services/api';
import { chain, map } from 'fp-ts/TaskEither';

const baseUrl = '/v2/integrations/webhook';

export const create = (instanceId: string) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody({ instance_id: instanceId })),
  chain(fetchApi),
);

export const remove = (instanceId: string) => pipe(
  `${baseUrl}/${instanceId}`,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);
